/*  MUI  */
import { Paper } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { PartnerVendorIncidentsTable } from './internal/PartnerVendorIncidentsTable';

export const PartnerVendorIncidents = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle title={t('Common.vendor_incidents')} />
            <Paper elevation={0} variant="outlined">
                <PartnerVendorIncidentsTable />
            </Paper>
        </>
    );
};
